"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JourneyActionAddInternalNote = void 0;
const base_1 = require("./base");
const enums_1 = require("../../enums");
const constants_1 = require("../constants");
const utils_1 = require("../utils");
const misc_1 = require("../../misc");
exports.JourneyActionAddInternalNote = (0, base_1.journeyAction)({
    action: enums_1.JourneyActionEnum.AddInternalNote,
    channels: (0, misc_1.EnumValues)(enums_1.ChannelEnum),
    settings_schema: (0, base_1.settingsValidationSchema)({
        user_id: {
            type: 'number',
            optional: true,
            allow: [null,],
            default: null,
        },
        queue_id: {
            type: 'number',
            optional: true,
            allow: [null,],
            default: null,
        },
        body: {
            type: 'string',
            required: true,
        },
    }),
    getPorts: (node) => {
        return Object.assign(Object.assign({}, base_1.journeyDefaultInputPort), { [constants_1.JOURNEY_ACTION_CLOSE_CONVERSATION_OUTPUT]: (0, utils_1.journeyNodePortAddDefault)({
                id: constants_1.JOURNEY_ACTION_ADD_INTERNAL_NOTE_OUTPUT,
                type: enums_1.JourneyPortDirectionEnum.Output,
                removable: false,
                required: false,
                index: 0,
                title: 'ADDED',
                color: null,
            }) });
    },
});
